<div
  class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
>
  <div class="bg-white rounded-lg p-8 w-full max-w-lg">
    <h2 class="text-2xl font-bold mb-6">
      {{
        modalType === ModalType.ADD_SUBCATEGORY
          ? "Unterkategorie hinzufügen"
          : modalType === ModalType.ADD
          ? "Kategorie hinzufügen"
          : "Kategorie bearbeiten"
      }}
    </h2>

    <div>
      <label for="title" class="block text-sm font-semibold mb-2">Titel</label>
      <input
        type="text"
        id="title"
        class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-6"
        placeholder="Beispiel Titel"
        [(ngModel)]="categoryForm.value.name"
      />
    </div>

    <div>
      <label for="description" class="block text-sm font-semibold mb-2"
        >Beschreibung</label
      >
      <textarea
        id="description"
        class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-6"
        placeholder="Beschreibung"
        [(ngModel)]="categoryForm.value.description"
      ></textarea>
    </div>

    <!-- Buttons -->
    <div class="flex justify-between space-x-4">
      <button
        (click)="onCancel()"
        class="bg-gray-300 hover:bg-gray-400 text-black py-2 px-4 focus:outline-none rounded-full"
      >
        Abbrechen
      </button>
      <button
        (click)="onSave()"
        class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 focus:outline-none rounded-full"
      >
        {{
          modalType === ModalType.ADD_SUBCATEGORY
            ? "Unterkategorie hinzufügen"
            : modalType === ModalType.ADD
            ? "Kategorie hinzufügen"
            : "Kategorie bearbeiten"
        }}
      </button>
    </div>
  </div>
</div>
